import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ngs_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function saveAuth(token, user) {
  localStorage.setItem("ngs_token", token);
  localStorage.setItem("ngs_user", JSON.stringify(user));
}
export function loadUser() {
  try { return JSON.parse(localStorage.getItem("ngs_user") || "null"); } catch { return null; }
}
export function logout() {
  localStorage.removeItem("ngs_token");
  localStorage.removeItem("ngs_user");
}

export const fmt$ = (n) => `$${Number(n || 0).toFixed(2)}`;

export const STATUS_COLORS = {
  "Pending Review": "bg-orange-500/15 text-orange-300 border-orange-500/40",
  "Alternate Time Proposed": "bg-blue-500/15 text-blue-300 border-blue-500/40",
  "Awaiting Deposit": "bg-yellow-500/15 text-yellow-300 border-yellow-500/40",
  "Confirmed": "bg-lime-500/15 text-lime-300 border-lime-500/40",
  "In Progress": "bg-purple-500/15 text-purple-300 border-purple-500/40",
  "Completed": "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  "Paid": "bg-emerald-600/25 text-emerald-200 border-emerald-500/60",
  "Cancelled": "bg-red-500/15 text-red-300 border-red-500/40",
};

export const PAYMENT_STATUS_COLORS = {
  "No Payment": "bg-zinc-500/15 text-zinc-300 border-zinc-500/40",
  "Awaiting Deposit": "bg-yellow-500/15 text-yellow-300 border-yellow-500/40",
  "Deposit Paid": "bg-blue-500/15 text-blue-300 border-blue-500/40",
  "Deposit Waived": "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/40",
  "Partially Paid": "bg-orange-500/15 text-orange-300 border-orange-500/40",
  "Paid in Full": "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  "Refunded": "bg-red-500/15 text-red-300 border-red-500/40",
};

export const APPT_STATUS_FILTERS = [
  { value: "", label: "All" },
  { value: "Pending Review", label: "Pending Requests" },
  { value: "Awaiting Deposit", label: "Awaiting Deposit" },
  { value: "Confirmed", label: "Confirmed" },
  { value: "In Progress", label: "In Progress" },
  { value: "Completed", label: "Completed" },
  { value: "Paid", label: "Paid" },
  { value: "Cancelled", label: "Cancelled" },
  { value: "__upcoming", label: "Upcoming" },
];
export const PAYMENT_STATUS_FILTERS = [
  { value: "", label: "All Payment States" },
  { value: "Deposit Waived", label: "Deposit Waived" },
  { value: "Deposit Paid", label: "Deposit Paid" },
  { value: "Partially Paid", label: "Partially Paid" },
  { value: "__unpaid", label: "Unpaid (no payment yet)" },
  { value: "Paid in Full", label: "Paid in Full" },
];
